import RateCardList, { RateCardListProps } from './RateCardList';

export type { RateCardListProps };
export default RateCardList;
